import React from 'react';
import PropTypes from 'prop-types';

import { noop } from 'util/function';

//

export const IFrameWidgetRenderer = ({ className, id, iframeSrc, onLoad }) => {
  const iframeRef = React.useRef(null);

  React.useEffect(() => {
    if (typeof onLoad === 'function' && iframeRef.current) {
      iframeRef.current.onload = () => onLoad(iframeRef);
    }

    // Change IFrame source to prevent it from affecting browser navigation buttons
    iframeRef.current?.contentWindow.location.replace(iframeSrc);
  }, [iframeSrc, onLoad]);

  return <iframe className={className} data-testid="widget-iframe" id={id} ref={iframeRef} scrolling="no" title={id} />;
};

IFrameWidgetRenderer.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  iframeSrc: PropTypes.string.isRequired,
  onLoad: PropTypes.func
};

IFrameWidgetRenderer.defaultProps = {
  onLoad: noop
};

export default IFrameWidgetRenderer;
